import { useMemo } from "react";
import { xyPositionRackItem } from "@utils/xyPositionRackItem";
import { INumberOfColumnsProps } from "./NumberOfColumn.props";

interface INumberOfColumnControl {
  readonly positionLeft?: number;
  readonly positionBottom?: number;
}

export const useNumberOfColumnControl = (
  props: Omit<INumberOfColumnsProps, "children">
): INumberOfColumnControl => {
  const [X, Y] = useMemo(() => {
    // const currentIndex = props.reversed
    //   ? props.rack_type[0] * props.rack_type[1] - 1 - props.index
    //   : props.index;
    const [X, Y] = xyPositionRackItem(props.index, props.rack_type);
    return [X, Y];
  }, [props.index, props.rack_type]);

  const positionLeft = X === 1 ? Y : undefined;
  const positionBottom = useMemo(() => {
    // if (!props.reversed)
    return Y === 1 ? X : undefined;
    // return Y === 1 ? X : undefined;
  }, [props.reversed, props.rack_type]);

  return {
    positionLeft,
    positionBottom,
  };
};
